import { RouteConfig } from "vue-router";
import { decisionModule } from "./module";

export const decisionRouteConfig: RouteConfig = {
  path: decisionModule.route,
  meta: { module: decisionModule },
  component: {
    render: (h) => h("router-view"),
  },
  children: [
    {
      path: "/",
      component: () => import("./DecisionList.vue"),
    },
    {
      path: ":id",
      meta: { action: " " },
      component: () => import("./DecisionItemView"),
    },
  ],
};
